import { gql } from '@apollo/client';

export const REMOVE_SAVED_JOB_NOTES = gql`
  mutation RemoveSavedJobNotes($jobId: ID!, $locale: Locale) {
    setSavedJobNotes(input: { id: $jobId, notes: "" }) {
      ... on SetSavedJobNotesSuccess {
        id
      }
      ... on SetSavedJobNotesFailure {
        errors {
          message(locale: $locale)
        }
      }
    }
  }
`;
